import { Box } from '@mui/material';
import { isDesktop } from 'react-device-detect';
import React, { CSSProperties } from 'react';
import { useZoom } from '../../ZoomProvider';
import { useConference } from '../../../Dolby';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'video-player-container': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

const ZoomCameraSharing = ({
  style = {},
  canvasHeight,
  canvasWidth,
}: {
  style?: CSSProperties;
  canvasWidth: number;
  canvasHeight: number;
}) => {
  return (
    <Box sx={style}>
      <video-player-container></video-player-container>

      <canvas
        id="remote-user-view-canvas"
        width={canvasWidth}
        height={canvasHeight}
      ></canvas>
    </Box>
  );
};

export default ZoomCameraSharing;
